// "X of Y trails open" on the public website. Caution is open trail —
// the rule lib/trailsStatus.js (and TrailsStatus on the server) states
// for every other surface — so a row counts unless it is closed or
// under maintenance. The bucket only picks a colour: counting
// `bucket === 'open'` read a site with one trail on caution as
// "0 of 1 trails open". Twin: SiteData::countsAsOpen.
//
// No Vue imports, so the harness can run it in node.
import { isTrailOpen } from '../../../lib/trailsStatus.js';

export const rowIsOpen = (row) => !!row && row.bucket !== 'closed' && isTrailOpen(row.condition);

export const openCount = (rows) => (rows || []).filter(rowIsOpen).length;
